export interface IWorkingDays {
  id: number;
  businessId: number;
  startCount: string;
  configType: number;
  days: IWorkingDay[];
  teamMemberId?: number;
  serviceId?: number;
  businessToolId?: number;
  isInherited?: boolean;
}

export interface IWorkingDay {
  id: number;
  scheduleConfigId: number;
  dayOfWeek: DayOfWeek;
  workingHourIntervals: IWorkingHour[];
}

export interface IWorkingHour {
  id: number;
  dayId: number;
  start: string;
  end: string;
}

export enum DayOfWeek {
  Sunday = "Sunday",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
}
